export default __webpack_public_path__ + "static/media/11-52.0b7ad533.png";